$("a[disabled]").click(function(e) {
  e.preventDefault();
});